export enum ColumnTypes {
    LeftColumn = 'leftColumn',
    RightColumn = 'rightColumn'
}
